// PROD
// export const apiDomain = "http://api.rsptoms.mhesi.go.th/";
// export const apiDomainFile = "http://api.rsptoms.mhesi.go.th/storage/";

// DEV
export const apiDomain = "https://sut-api.ksta.co/";
export const apiDomainFile = "https://sut-api.ksta.co/storage/";

// LOCAL
// export const apiDomain = "http://localhost:8000/";
// export const apiDomainFile = "http://localhost:8000/storage/";

















